import './index.css';

import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import darkIcon from '../favicon_apple.png';
import lightIcon from '../favicon_apple_white.png';
import DevelopersContent from './pages/Developers';

export const App = () => {
  const [faviconHref, setFaviconHref] = useState(darkIcon);

  /**
   * Returns the path for a favicon based on the given color scheme.
   *
   * @param {boolean} isDarkMode If currently in dark mode
   */
  const getFaviconPath = (isDarkMode = false) => {
    if (!isDarkMode) return darkIcon;
    else return lightIcon;
  };

  useEffect(() => {
    // Get current color scheme.
    const matcher = window.matchMedia(`(prefers-color-scheme: dark)`);
    // Set favicon initially.
    setFaviconHref(getFaviconPath(matcher.matches));
    // Change favicon if the color scheme changes.
    matcher.onchange = () => setFaviconHref(getFaviconPath(matcher.matches));
  }, [faviconHref]);

  console.info(`FORCE DEPLOY - Optimization Live & Driver Stop Management`);

  return (
    <>
      <Helmet>
        <link rel="icon" href={faviconHref} />
      </Helmet>
      <DevelopersContent />;
    </>
  );
};
